import { cn } from '@heidi/utils';

import type { ObjectCreationKind } from '../../../../data/projects/timeline/object-card/object-creation.types';
import { objectKindIcon } from './objectKindIcon';

const TILE_BASE = 'size-[120px] rounded-lg border border-border bg-surface';

const TILE_FAN_TRANSITION = 'transition-transform duration-300 ease-out';

interface ObjectCreationIllustrationProps {
  kind: ObjectCreationKind;
  /** Fan extra tiles behind the primary one to imply multiple objects. */
  stacked?: boolean;
  className?: string;
}

export const ObjectCreationIllustration = ({
  kind,
  stacked = false,
  className,
}: ObjectCreationIllustrationProps): JSX.Element => {
  const Icon = objectKindIcon(kind);

  const front = (
    <div className={cn(TILE_BASE, 'flex items-start justify-center pt-7')}>
      <Icon className="size-5 text-text-tertiary" strokeWidth={1.5} />
    </div>
  );

  if (!stacked) {
    return (
      <div className={cn('shrink-0', className)} aria-hidden>
        {front}
      </div>
    );
  }

  return (
    <div className={cn('relative size-[120px] shrink-0', className)} aria-hidden>
      <div
        className={cn(
          TILE_BASE,
          TILE_FAN_TRANSITION,
          'absolute inset-0 translate-x-4 translate-y-3 rotate-6',
          'group-hover:translate-x-6 group-hover:translate-y-3.5 group-hover:rotate-[10deg]'
        )}
      />
      <div
        className={cn(
          TILE_BASE,
          TILE_FAN_TRANSITION,
          'absolute inset-0 translate-x-2 translate-y-1.5 rotate-3',
          'group-hover:translate-x-3 group-hover:translate-y-2 group-hover:rotate-[5deg]'
        )}
      />
      <div className="relative">{front}</div>
    </div>
  );
};
